// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/aivo contact us.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-contact{
    display: flex;
}
.first-contact{
    width: 50%;
    margin-top: 50px;
    margin-left: 50px;
    display: flex;
    flex-direction: column;
}
.second-contact{
    width: 50%;
    margin-top: 50px;
}
.contact-background{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    height: 300px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    justify-content: center;
}
.firt-con-call{
    display: flex;
    gap: 20px;
}
.first-con-depart{
    display: flex;
    gap: 20px;
    margin-top: 20px;
}
.first-con-depar {
    display: flex;
    gap: 20px;
    margin-top: 20px;
}
.last-box{
    display: flex;
    background: #0098db;
    width: 80%;
    padding: 10px;
    flex-direction: column;
}
.last-box-button{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
@media (max-width:800px) {
    .main-contact{
        flex-direction: column;
    }
    .first-contact{
        width: 100%;
        margin-left: 0px;
    }
    .second-contact{
        width: 100%;
    }
    .firt-con-call{
        flex-direction: column;
    }
    .first-con-depart{
        flex-direction: column;
    }
  
    .first-con-depar{
        flex-direction: column;
    }
    .last-box{
        width: 100%;
    }
}

.dts{
    width: 45%;
}
@media (max-width:'600px'){
    .dts{
        width:100%;
        min-width:300px
    }
}
dtsi{
    min-width: 300px;
}

.halftofull{
    grid-template-columns: 1fr 1fr;
}

.hovbut:hover{
   transform:scale(1.05) 0.3s 
}`, "",{"version":3,"sources":["webpack://./src/Contactus.js/Maincontact.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,yDAAwD;IACxD,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,UAAU;AACd;AACA;IACI;QACI,UAAU;QACV;IACJ;AACJ;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;GACG;AACH","sourcesContent":[".main-contact{\n    display: flex;\n}\n.first-contact{\n    width: 50%;\n    margin-top: 50px;\n    margin-left: 50px;\n    display: flex;\n    flex-direction: column;\n}\n.second-contact{\n    width: 50%;\n    margin-top: 50px;\n}\n.contact-background{\n    background-image: url(\"../Images/aivo\\ contact\\ us.png\");\n    background-size: cover;\n    background-position: center;\n    height: 300px;\n    display: flex;\n    flex-direction: column;\n    margin-top: 50px;\n    justify-content: center;\n}\n.firt-con-call{\n    display: flex;\n    gap: 20px;\n}\n.first-con-depart{\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n}\n.first-con-depar {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n}\n.last-box{\n    display: flex;\n    background: #0098db;\n    width: 80%;\n    padding: 10px;\n    flex-direction: column;\n}\n.last-box-button{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n@media (max-width:800px) {\n    .main-contact{\n        flex-direction: column;\n    }\n    .first-contact{\n        width: 100%;\n        margin-left: 0px;\n    }\n    .second-contact{\n        width: 100%;\n    }\n    .firt-con-call{\n        flex-direction: column;\n    }\n    .first-con-depart{\n        flex-direction: column;\n    }\n  \n    .first-con-depar{\n        flex-direction: column;\n    }\n    .last-box{\n        width: 100%;\n    }\n}\n\n.dts{\n    width: 45%;\n}\n@media (max-width:'600px'){\n    .dts{\n        width:100%;\n        min-width:300px\n    }\n}\ndtsi{\n    min-width: 300px;\n}\n\n.halftofull{\n    grid-template-columns: 1fr 1fr;\n}\n\n.hovbut:hover{\n   transform:scale(1.05) 0.3s \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
